import { render } from "./FeedView.vue?vue&type=template&id=5b4f5cb6&scoped=true"
import script from "./FeedView.vue?vue&type=script&lang=js"
export * from "./FeedView.vue?vue&type=script&lang=js"

import "./FeedView.vue?vue&type=style&index=0&id=5b4f5cb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4f5cb6"]])

export default __exports__